import { forwardRef } from 'react'
import cn from 'clsx'
import { FaSearch } from 'react-icons/fa'

import './SearchInput.css'

/**
 * Text input with search icon embedded on left side
 * All extra properties are passed directly to the input
 * 
 * @param className Wrapper classes
 * @param inputClassName Input classes
 * @param props Extra input props
 * @returns {JSX.Element}
 * @constructor
 */
const SearchInput = forwardRef(({
    className,
    iconClassName,
    iconWrapClassName,
    inputClassName,
    ...props
}, ref) => {
    
    return (
        
        <label id="SearchInput" className={cn('SearchInput hidden md:block', className)}>
            
            <span className={cn('icon-wrap', iconWrapClassName)}>
                <FaSearch className={cn('text-sm', iconClassName)} />
            </span>
            
            <input
                ref={ref}
                className={cn('input input-bordered bg-transparent w-full !pl-10', inputClassName)}
                type="search"
                {...props} />
        
        </label>
        
    )
    
})

SearchInput.displayName = 'SearchInput'

export default SearchInput
